import { render, staticRenderFns } from "./DeadlineAlert.vue?vue&type=template&id=080c49ae&scoped=true&"
import script from "./DeadlineAlert.vue?vue&type=script&lang=js&"
export * from "./DeadlineAlert.vue?vue&type=script&lang=js&"
import style0 from "./DeadlineAlert.vue?vue&type=style&index=0&id=080c49ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080c49ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
